<nav class="dialog-tab-nav">
  @for (tab of tabs(); track tab.id) {
    <button
      type="button"
      class="dialog-tab-nav__item"
      [class.dialog-tab-nav__item--active]="isActive(tab.id)"
      [class.dialog-tab-nav__item--invalid]="isInvalid(tab.id)"
      (click)="onTabClick(tab.id)"
    >
      @if (tab.icon) {
        <fa-icon [icon]="tab.icon" class="dialog-tab-nav__icon"></fa-icon>
      }
      @if (tab.count) {
        <span
          class="dialog-tab-nav__label"
          [attr.data-label]="tab.label + ' (' + tab.count + ')'"
          >{{ tab.label + " (" + tab.count + ")" }}</span
        >
      } @else {
        <span class="dialog-tab-nav__label" [attr.data-label]="tab.label">{{
          tab.label
        }}</span>
      }
      @if (getInvalidCount(tab.id); as invalidCount) {
        <span class="dialog-tab-nav__error">
          <fa-icon
            [icon]="warningIcon"
            class="dialog-tab-nav__error-icon"
          ></fa-icon>
          <span class="dialog-tab-nav__error-count">{{ invalidCount }}</span>
        </span>
      }
    </button>
  }
</nav>
